import React, { PropsWithChildren } from 'react';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import FormModal from 'components/PreferenceModals/FormModal';
import ConfirmationModal from 'components/PreferenceDialog/Success';
import ErrorModal from 'components/PreferenceDialog/Error';
import SheetActionButton from 'components/Layout/MobileShell/SheetActionButton';
import { SavePreferenceState } from 'components/Meteorology/Shared/ControlPanelSheet/DetailedView/types';

import './index.scss';

export interface SheetFrameProps {
  open: boolean;
  dismiss: () => void;
  /** Classe do BottomSheet (específica de cada domínio). */
  className?: string;
  savePreference: SavePreferenceState;
  triggerRequest: (() => void) | undefined;
  clearSelection: () => void;
}

/**
 * Casca do painel de controle mobile da Visão Detalhada: BottomSheet, modais de salvar
 * preferência, corpo (seções) e rodapé (salvar / consultar / limpar).
 */
export default function SheetFrame({
  open,
  dismiss,
  className,
  savePreference,
  triggerRequest,
  clearSelection,
  children,
}: PropsWithChildren<SheetFrameProps>) {
  const confirm = () => {
    if (triggerRequest) triggerRequest();
    dismiss();
  };

  return (
    <BottomSheet
      open={open}
      dismiss={dismiss}
      title="Painel de controle"
      className={className}
    >
      <FormModal
        show={savePreference.showFormModal}
        onHide={() => savePreference.setShowFormModal(false)}
        valid={savePreference.valid}
        isLoading={savePreference.isLoading}
        onNameChange={savePreference.onNameChange}
        handleSubmit={savePreference.handleSubmit}
      />
      <ConfirmationModal
        open={savePreference.showConfirmationModal}
        closing={() => savePreference.setShowConfirmationModal(false)}
      />
      <ErrorModal
        open={savePreference.showErrorModal}
        closing={() => savePreference.setShowErrorModal(false)}
        message={savePreference.errorMessage}
      />

      <div className="control-panel-sheet-dv-body">{children}</div>

      <div className="control-panel-sheet-dv-footer">
        <SheetActionButton
          variant="secondary"
          disabled={savePreference.disabled}
          onClick={() => savePreference.setShowFormModal(true)}
        >
          Salvar nova preferência
        </SheetActionButton>
        <SheetActionButton
          variant="confirm"
          disabled={triggerRequest === undefined}
          onClick={confirm}
        >
          Realizar consulta
        </SheetActionButton>
        <SheetActionButton variant="clear" onClick={clearSelection}>
          Limpar gráfico
        </SheetActionButton>
      </div>
    </BottomSheet>
  );
}
